import { EventEmitter } from 'events'

export enum DashboardAlertEventKind {
    'OPEN_ALERT_MANAGEMENT_DRAWER' = 'OPEN_ALERT_MANAGEMENT_DRAWER',
    'WIDGET_INFO' = 'WIDGET_INFO',
    'CHANNEL_ASSET_INFO' = 'CHANNEL_ASSET_INFO'
}

const Emitter = new EventEmitter()

class CustomEmitter {
    emit<T>(event: DashboardAlertEventKind, val?: T): void {
        Emitter.emit(event, val)
    }

    on<T>(event: DashboardAlertEventKind, listener: (val?: T) => void): void {
        Emitter.on(event, listener)
    }
}

// TODO: move it to redux
export const DashboardAlertEmitter = new CustomEmitter()
